/* src/app/components/control-module/new-process/new-process.component.css */
/*# sourceMappingURL=new-process.component.css.map */
